import hamburgerIcon from '../icons/navigation_hamburger_icon.svg';
import hamburgerIconAnimate from '../icons/navigation_hamburger_icon_animate.svg';
import xIconAnimate from '../icons/navigation_x_icon_animate.svg';
import xIcon from '../icons/navigation_x_icon.svg';

document.addEventListener('DOMContentLoaded', () => {

    const navBarWrapper = document.querySelector('.ormandy-original-nav-bar-wrapper');
    const navBar = navBarWrapper.querySelector('.ormandy-original-nav-bar');
    const navTitle = navBarWrapper.querySelector('.ormandy-original-nav-bar-title');
    const navLogo = navBarWrapper.querySelector('.ormandy-original-nav-bar-logo');
    let MenuItems = navBarWrapper.querySelectorAll('.ormandy-original-nav-bar > .ormandy-original-nav-bar-content > .ormandy-original-navigation');
    let expandableItems = navBarWrapper.querySelectorAll('.ormandy-original-nav-bar > .ormandy-original-nav-bar-content > .ormandy-original-navigation > ul.ormandy-menu > li:has(ul.sub-menu)');
    let mobileExpandableItems;

    function hoverMenuInit(itemList) {

        itemList.forEach((item) => {

            const subMenu = item.querySelector('ul.sub-menu');
            const expandButton = document.createElement('div');
            expandButton.classList.add('ormandy-original-nav-bar-expand-button');
            item.insertBefore(expandButton, item.childNodes[1]);

            let isHovering;

            function openOnClick() {
                subMenu.style.setProperty('opacity', '1', 'important');
                subMenu.classList.add('sub-menu-toggle');
                setTimeout(() => {
                    document.addEventListener('click', closeOnClick, { once: true });
                    item.removeEventListener('mouseleave', closeOnHover);
                    expandButton.removeEventListener('click', openOnClick);
                }, 1);
                item.style.setProperty('z-index', '10000');
            }

            function closeOnClick() {
                subMenu.style.setProperty('opacity', '0', 'important');
                expandButton.addEventListener('click', openOnClick);
                item.addEventListener('mouseleave', closeOnHover);
                setTimeout(() => {
                    subMenu.classList.remove('sub-menu-toggle');
                    subMenu.style.setProperty('opacity', '0', '');
                    item.style.setProperty('z-index', 'unset');
                }, 400);
            }

            function openOnHover() {
                isHovering = true;
                subMenu.style.setProperty('opacity', '1', 'important');
                subMenu.classList.add('sub-menu-toggle');
                item.style.setProperty('z-index', '10000');
            }

            function closeOnHover() {
                isHovering = false
                subMenu.style.setProperty('opacity', '0', 'important');
                setTimeout(() => {
                    if (!isHovering) {
                        subMenu.classList.remove('sub-menu-toggle');
                        subMenu.style.setProperty('opacity', '0', '');
                        item.style.setProperty('z-index', 'unset');
                    }
                }, 500);
            }

            expandButton.addEventListener('click', openOnClick);

            item.addEventListener('mouseenter', openOnHover);

            item.addEventListener('mouseleave', closeOnHover);

        });
        setTimeout(() => {
            MenuItems.forEach((item) => {
                item.style.setProperty('visibility', 'visible');
                item.style.setProperty('opacity', '1');
            });
            if(navTitle) {
                if(getComputedStyle(navTitle).opacity === '0') {
                    navTitle.style.setProperty('visibility', 'visible');
                    navTitle.style.setProperty('opacity', '1');
                    navLogo.style.setProperty('opacity', '1')
                }
            }
        }, 50);
    }

    hoverMenuInit(expandableItems);

    // Scroll Animation

    const isAnimated = navBarWrapper.querySelector('#scroll-animate-marker');

    if(isAnimated) {
        scrollAnimationInit();
        navLogo.style.setProperty('opacity', '1')
    } else {
        navBar.classList.add('ormandy-original-nav-bar-wrapper-no-anim');
    }

    function scrollAnimationInit() {
        
        let scrolled;

        function windowScrollCheck() {
            if(window.scrollY <= 0) {
                return false
            } else if ( window.scrollY > 0) {
                return true
            }
        }

        function animateIn(windowCheck) {
            scrolled = windowScrollCheck();
            if(scrolled) {
                if(windowCheck.currentTarget === window) {
                    navBarWrapper.id = 'ormandy-original-nav-bar-wrapper';
                    navBar.classList.add('ormandy-original-nav-bar-wrapper-no-anim');
                    setTimeout(() => {
                        navBar.classList.add('ormandy-original-nav-bar-wrapper-post-anim');
                        navBar.classList.remove('ormandy-original-nav-bar-wrapper-no-anim');
                    }, 0.1);
                } else {
                    navBarWrapper.id = 'ormandy-original-nav-bar-wrapper';
                    navBar.classList.add('ormandy-original-nav-bar-wrapper-post-anim');
                }
            } else if (!scrolled) {
                navBar.classList.remove('ormandy-original-nav-bar-wrapper-post-anim');
            }
        }

        navBar.classList.add('ormandy-original-nav-bar-wrapper-pre-anim');

        window.addEventListener('load', animateIn, {once: true});

        document.addEventListener('scroll', animateIn);

    }

    
    // Mobile scaling

    let lastKnownWidth = 10000;
    let firstScalingInit = true;
    let firstMenuInit = true;
    let firstOpen = true;
    window.addEventListener('resize', mobileScalingInit);
    window.addEventListener('load', mobileScalingInit);
    const hbgMenu = document.createElement('div');

    function mobileScalingInit() {

        const winWidth = window.innerWidth;
        const nav = navBar.querySelector('.ormandy-original-navigation')

        const mobileNav = document.createElement('ul');
        mobileNav.classList.add('ormandy-menu', 'ormandy-original-navigation-mobile');
        mobileNav.id = 'menu-navigation';
        mobileNav.innerHTML = nav.querySelector('ul').innerHTML;

        function expandableMenuInit(itemList) {

            itemList.forEach((item) => {

                const subMenu = item.querySelector('ul.sub-menu');
                const mobileExpandButton = document.createElement('div');

                if(firstMenuInit) {
                    mobileExpandButton.classList.add('ormandy-original-mobile-nav-bar-expand-button');
                    item.insertBefore(mobileExpandButton, item.childNodes[1]);

                    if(Array.from(itemList).indexOf(item) + 1 === Array.from(itemList).length) {
                        firstMenuInit = false;
                    }
                }

                async function expandOnClick() {
                    item.style.setProperty('max-height', '1000px', 'important');
                    subMenu.style.setProperty('opacity', '1', 'important');
                    subMenu.classList.add('sub-menu-toggle');
                    mobileExpandButton.addEventListener('click', collapseOnClick, { once: true });
                    item.style.setProperty('z-index', '10000');
                }
                
                async function collapseOnClick() {
                    item.style.setProperty('max-height', '35pc', '');
                    subMenu.style.setProperty('opacity', '0', 'important');
                    mobileExpandButton.addEventListener('click', expandOnClick, {once: true});
                    subMenu.classList.remove('sub-menu-toggle');
                    subMenu.style.setProperty('opacity', '0', '');
                    item.style.setProperty('z-index', 'unset');
                }
                
                mobileExpandButton.addEventListener('click', expandOnClick, {once: true});
                
            });
        }
        
        function openMobileNav() {
            
            const hbgIcon = navBarWrapper.querySelector('.ormandy-original-navigation').querySelector('img.ormandy-original-navigation-hamburger');
            const openBlobUrl = new Blob([atob(xIconAnimate.split(',')[1])], { type: 'image/svg+xml' });
            hbgIcon.src = URL.createObjectURL(openBlobUrl);
            hbgIcon.alt = 'Navigation Menu Toggle';
            setTimeout(() => {
                hbgIcon.src = xIcon;
                hbgMenu.addEventListener('click', closeMobileNav, { once: true });
            }, 550);
            
            // mobileNav.classList.add('ormandy-original-mobile-nav-bar-fade-out');
            navBar.appendChild(mobileNav);
            navBar.querySelector('.ormandy-original-navigation-mobile').querySelectorAll('.ormandy-original-nav-bar-expand-button').forEach((el) => {
                el.remove();            
            });

            navBar.classList.add('ormandy-original-nav-bar-expand');
            document.body.style.setProperty('overflow-y', 'hidden');
            setTimeout(() => {
                mobileNav.classList.remove('ormandy-original-mobile-nav-bar-fade-out');
            }, 50);

            if(firstOpen) {
                mobileExpandableItems = navBarWrapper.querySelectorAll('.ormandy-original-nav-bar > ul.ormandy-menu > li:has(ul.sub-menu)');
                expandableMenuInit(mobileExpandableItems);
            }

        }

        function closeMobileNav() {

            const hbgIcon = navBarWrapper.querySelector('.ormandy-original-navigation').querySelector('img.ormandy-original-navigation-hamburger');
            const closeBlobUrl = new Blob([atob(hamburgerIconAnimate.split(',')[1])], { type: 'image/svg+xml' });
                hbgIcon.src = URL.createObjectURL(closeBlobUrl);
                hbgIcon.alt = 'Navigation Menu Toggle';
            setTimeout(() => {
                hbgIcon.src = hamburgerIcon;
                hbgMenu.addEventListener('click', openMobileNav, {once: true});
            }, 550);

            mobileNav.classList.add('ormandy-original-mobile-nav-bar-fade-out');
            setTimeout(() => {
                navBar.classList.remove('ormandy-original-nav-bar-expand');
                document.body.style.setProperty('overflow-y', 'unset');
                setTimeout(() => {
                    mobileNav.remove();
                }, 50);
            }, 50);

        }
        
        if(winWidth <= 875 && lastKnownWidth >= 875) {
            
            if(firstScalingInit) {
                hbgMenu.innerHTML = `
                    <img class='ormandy-original-navigation-hamburger' alt='Navigation Menu Toggle Toggle' src='${hamburgerIcon}' />
                `;
                hbgMenu.addEventListener('click', openMobileNav, {once: true});
                firstScalingInit = false;
            }
            nav.appendChild(hbgMenu);
            const mobileNavEl = navBarWrapper.querySelector('.ormandy-original-navigation-mobile')
            if(mobileNavEl) {
                mobileNavEl.style.setProperty('display', 'unset');
                hbgMenu.style.display = 'unset';
            }

        } else if (winWidth >= 875 && nav.querySelector('.ormandy-original-navigation-hamburger')) {
            const mobileNavEl = navBarWrapper.querySelector('.ormandy-original-navigation-mobile')
            if(mobileNavEl) {
                mobileNavEl.style.setProperty('display', 'none');
                hbgMenu.removeEventListener('click', openMobileNav);
                hbgMenu.removeEventListener('click', closeMobileNav);
                hbgMenu.style.display = 'none';
                document.body.style.setProperty('overflow-y', 'unset');
            }

        }

        lastKnownWidth = winWidth;
    }

});